import ArticleCard from './ArticleCard'
import { TagArticles_tagArticles_articles } from '@apollo-types/TagArticles'

interface ArticleCardContainerProps {
  index?: number
  article: TagArticles_tagArticles_articles
  tag?: string
}

function ArticleCardContainer(props: ArticleCardContainerProps) {
  const { article } = props

  return <ArticleCard article={article} />
}

export default ArticleCardContainer
